import { Icon } from '@fourthwall/components';
import { ArrowShortRightIcon, TickIcon } from '@fourthwall/icons';
import React from 'react';
import { getDirectParentFromBreadcrumbs } from '../../../../utils/breadcrumbs';
import { SearchedText } from '../SearchedText';
import * as S from './styled';
export const Option = ({ searchValue, option, selected, isFocused, onSelect, onNavigateDown, }) => {
    const hasChildren = option.children.length > 0;
    const hasInnerClick = hasChildren && !searchValue;
    const handleOuterClick = (e) => {
        e.stopPropagation();
        hasInnerClick ? onNavigateDown(option) : onSelect(option);
    };
    const renderRightContent = () => {
        if (searchValue) {
            return React.createElement(S.Parent, null, getDirectParentFromBreadcrumbs(option.breadcrumbs));
        }
        if (hasChildren) {
            return (React.createElement(S.IconContainer, null,
                React.createElement(Icon, { component: ArrowShortRightIcon, height: 12 })));
        }
        if (selected) {
            return (React.createElement(S.IconContainer, { "$bold": true },
                React.createElement(Icon, { component: TickIcon, height: 12 })));
        }
        return null;
    };
    return (React.createElement(S.Container, { "$selected": selected, "$focused": isFocused, tabIndex: -1, onClick: handleOuterClick },
        React.createElement(S.CategoryButton, { "$selected": selected }, searchValue ? React.createElement(SearchedText, { text: option.name, search: searchValue }) : option.name),
        renderRightContent()));
};
